import type { FooterProps } from '@goodfynd/layout';

import routes from '../../config/routes';

export const STANDARD_FOOTER: FooterProps = {
  logo_type: 'default-white',
  social_links: [
    {
      icon_name: 'twitter',
      url: routes.social.twitter,
      alt: 'Goodfynd on Twitter',
    },
    {
      icon_name: 'linkedin',
      url: routes.social.linkedIn,
      alt: 'Goodfynd on LinkedIn',
    },
    {
      icon_name: 'instagram',
      url: routes.social.instagram,
      alt: 'Goodfynd on Instagram',
    },
    {
      icon_name: 'facebook',
      url: routes.social.facebook,
      alt: 'Goodfynd on Facebook',
    },
  ],
  footer_links_1: {
    name: 'Let Us Help You',
    menu_items: [
      {
        label: 'Find a Truck',
        url: routes.search.vendors,
      },
      {
        label: 'Book a Truck',
        url: routes.events.home,
      },
      {
        label: 'List Your Truck',
        url: routes.vendors.home,
      },
    ],
  },
  footer_links_2: {
    name: 'Your Account',
    menu_items: [
      {
        label: 'Account Details',
        url: routes.account.home,
      },
    ],
  },
  footer_links_3: {
    name: 'Support',
    menu_items: [
      {
        label: 'Chat With Us',
        url: '',
        class: 'drift-button',
      },
    ],
  },
  footer_links_4: {
    name: 'Get to Know Us',
    menu_items: [
      {
        label: 'Careers',
        url: routes.careers,
      },
      {
        label: 'Blog',
        url: routes.blog,
      },
    ],
  },
  legal_links: {
    name: 'Legal Links',
    menu_items: [
      {
        label: 'Privacy Policy',
        url: routes.legal.privacy,
      },
      {
        label: 'Fulfillment Policy',
        url: routes.legal.fulfillment,
      },
      {
        label: 'Terms of Service',
        url: routes.legal.terms,
      },
      {
        label: 'Cookie Policy',
        url: routes.legal.cookies,
      },
      {
        label: 'Privacy Notice California',
        url: routes.legal.california,
      },
    ],
  },
};
